<template>
  <div class="membership-page">
    <van-nav-bar :title="$t('membership.title') || 'Membership'" class="custom-nav" :border="false">
      <template #left>
        <van-icon name="arrow-left" color="#e6b98a" size="24" @click="$router.go(-1)" />
      </template>
    </van-nav-bar>
    <div class="page-title">{{ $t('membership.page_title') }}</div>
    
    <!-- 普通等级卡片 -->
    <div class="level-card normal-level">
      <div class="vip-badge">
        <img src="/img/vip.png" alt="VIP" class="vip-icon" />
      </div>
      <div class="card-content">
        <div class="level-title">{{ $t('membership.normal_level') }}</div>
        <div class="level-desc">({{ $t('membership.watch_video_free') }}) ({{ $t('membership.pairing_free') }})</div>
      </div>
      <div class="status" @click="goToStart" v-if="userInfo && (!userInfo.vip || userInfo.vip === 'Normal')">{{ $t('membership.current_level') }}</div>
    </div>

    <!-- 动态生成VIP等级卡片 -->
    <div 
      v-for="level in allLevels" 
      :key="level.id" 
      :class="['level-card', getLevelClass(level.name)]"
    >
      <div class="vip-badge">
        <img src="/img/vip.png" alt="VIP" class="vip-icon" />
      </div>
      <div class="card-content">
        <div class="level-title">{{ level.name }}</div>
        <div class="level-desc">
          <div>{{ $t('membership.required_investment') }} ${{ level.min_amount }}</div>
          <div>{{ $t('membership.commission') }} {{ level.commission_rate }}% | {{ level.order_count }} {{ $t('membership.order') }}</div>
        </div>
      </div>
             <div class="status" @click="goToStart" v-if="userInfo && userInfo.vip === level.name">{{ $t('membership.current_level') }}</div>
       <div class="join-button" v-else-if="shouldShowJoinButton(level.name)" @click="goToServiceOnline">{{ $t('membership.join') }}</div>
    </div>

    <!-- Data Card卡片 -->
    <!--<div class="level-card data-card-level">
      <div class="vip-badge">
        <img src="/img/vip.png" alt="VIP" class="vip-icon" />
      </div>
      <div class="card-content">
        <div class="level-title">{{ $t('membership.date_card') }}</div>
        <div class="level-desc">
          <div class="data-status">{{ $t('membership.state') }}: {{ $t('membership.not_activated') }}</div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import http from '@/http/index'

export default {
  name: 'MembershipPage',
  data() {
    return {
      userInfo: null,
      allLevels: [],
      loading: false,
      lang: 'zh'
    }
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || 'zh';
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    goToStart() {
      console.log('goToStart method called');
      console.log('Current route:', this.$route.path);
      this.$router.push('/Start').catch(err => {
        console.error('Navigation error:', err);
      });
    },
    
    goToServiceOnline() {
      console.log('goToServiceOnline method called');
      this.$router.push('/ServiceOnline').catch(err => {
        console.error('Navigation error:', err);
      });
    },
    
    // 获取用户信息
    async getUserInfo() {
      try {
        this.loading = true
        const result = await http({
          method: 'get',
          url: 'user_info',
          data: {}
        })
        
        if (result && result.code === 200) {
          this.userInfo = result.data
          // 获取等级信息
          if (result.data.all_levels && Array.isArray(result.data.all_levels)) {
            this.allLevels = result.data.all_levels
            console.log('等级信息获取成功:', this.allLevels)
          }
          console.log('用户信息获取成功:', this.userInfo)
        } else {
          console.error('获取用户信息失败:', result.msg)
        }
      } catch (error) {
        console.error('获取用户信息出错:', error)
      } finally {
        this.loading = false
      }
    },
    
    // 根据等级名称获取对应的CSS类
    getLevelClass(levelName) {
      const levelMap = {
        'VIP1': 'vip1-level',
        'VIP2': 'vip2-level',
        'VIP3': 'vip3-level',
        'VIP4': 'vip4-level'
      }
      return levelMap[levelName] || 'vip1-level'
    },
    
    // 判断是否应该显示加入按钮
    shouldShowJoinButton(levelName) {
      if (!this.userInfo || !this.userInfo.vip) {
        // 如果没有用户信息或VIP等级，显示所有等级的加入按钮
        return true;
      }
      
      // 获取当前用户等级和要显示的等级
      const currentLevel = this.getLevelNumber(this.userInfo.vip);
      const targetLevel = this.getLevelNumber(levelName);
      
      // 只显示比当前等级更高的等级
      return targetLevel > currentLevel;
    },
    
    // 获取等级对应的数字
    getLevelNumber(levelName) {
      const levelMap = {
        'Normal': 0,
        'VIP1': 1,
        'VIP2': 2,
        'VIP3': 3,
        'VIP4': 4
      }
      return levelMap[levelName] || 0;
    }
  }
}
</script>

<style lang="less" scoped>
.membership-page {
  background-color: #000;
  padding: 20px;
  padding-bottom: 40px; /* Remove large bottom padding since there's no tabbar */
  overflow-y: auto; // 确保可以垂直滚动
  min-height: 100vh;
  box-sizing: border-box;
  
  // 适配不同屏幕尺寸
  @media (max-width: 768px) {
    padding: 16px;
    padding-bottom: 30px;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
    padding-bottom: 20px;
  }
}

/* 导航栏暗金风格 */
.custom-nav {
  background-color: #000 !important;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: 20px;
}
::v-deep .custom-nav .van-nav-bar__title {
  color: #e6b98a !important;
  font-size: 32px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

.page-title {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 24px;
  text-align: center;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
    margin-bottom: 16px;
  }
}



.level-card {
  position: relative;
  border-radius: 18px;
  padding: 28px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  overflow: hidden;
  
  // 最后一个卡片不需要底部间距
  &:last-child {
    margin-bottom: 0;
  }
  
  // 添加背景水印
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 240px;
    height: 96px;
    background: url('/img/vip-bg.png') no-repeat center center;
    background-size: contain;
    opacity: 1;
    z-index: 10;
    pointer-events: none; // 确保不阻挡点击事件
  }
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    padding: 24px;
    margin-bottom: 20px;
    border-radius: 16px;
    
    &::after {
      width: 200px;
      height: 80px;
    }
  }
  
  @media (max-width: 480px) {
    padding: 20px;
    margin-bottom: 16px;
    border-radius: 14px;
    
    &::after {
      width: 160px;
      height: 64px;
    }
  }
}

.normal-level {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.vip1-level {
  background: linear-gradient(135deg, #34495e 0%, #5d6d7e 100%);
}

.vip2-level {
  background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
}

.vip3-level {
  background: linear-gradient(135deg, #1a237e 0%, #283593 100%);
}

.vip4-level {
  background: linear-gradient(135deg, #4a148c 0%, #6a1b9a 100%);
}

.data-card-level {
  background: linear-gradient(135deg, #00695c 0%, #004d40 100%);
}

.vip-badge {
  width: 65px;
  height: 85px;
  background: #fff;
  border-radius: 9px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 22px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 4px;
    height: 8px;
    background: #e74c3c;
    border-radius: 2px;
  }
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    width: 60px;
    height: 78px;
    margin-right: 20px;
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    width: 55px;
    height: 70px;
    margin-right: 18px;
    border-radius: 7px;
  }
}

.vip-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.card-content {
  flex: 1;
  color: #fff;
  margin-right: 120px; // 为右上角按钮留出空间
}

.level-title {
  font-size: 21px;
  font-weight: bold;
  margin-bottom: 9px;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 19px;
    margin-bottom: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 17px;
    margin-bottom: 7px;
  }
}

.level-desc {
  font-size: 15px;
  line-height: 1.4;
  opacity: 0.9;
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 14px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
  }
}

.status {
  color: #fff;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  padding: 9px 18px;
  border: 2px solid #fff;
  border-radius: 9px;
  transition: all 0.3s ease;
  user-select: none;
  display: inline-block;
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10;
  margin: 0;
  
  &:hover {
    background: #fff;
    color: #000;
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 8px 16px;
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 15px;
    padding: 7px 14px;
    border-radius: 7px;
  }
}

.join-button {
  color: #fff;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  padding: 9px 18px;
  border: 2px solid #fff;
  border-radius: 9px;
  transition: all 0.3s ease;
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10;
  margin: 0;
  
  &:hover {
    background: #fff;
    color: #000;
  }
  
  // 移动端适配 - 只调整尺寸，保持布局
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 8px 16px;
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 15px;
    padding: 7px 14px;
    border-radius: 7px;
  }
}

// 水印图片样式
.card-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 240px;
  height: 96px;
  opacity: 1;
  z-index: 5;
  pointer-events: none;
}

// 确保内容在水印之上
.vip-badge,
.card-content {
  position: relative;
  z-index: 10;
}

.status,
.join-button {
  z-index: 10;
}

.data-status {
  color: #b0b0b0;
  font-style: italic;
}

.member-price {
  color: #ffd700;
  font-weight: bold;
  margin-top: 5px;
}

// 横屏适配 - 只调整尺寸，保持布局
@media (orientation: landscape) and (max-height: 600px) {
  .membership-page {
    padding: 12px;
  }
  
  .level-card {
    margin-bottom: 12px;
    padding: 16px;
  }
  
  .page-title {
    margin-bottom: 16px;
  }
}

// 大屏幕适配 - 只调整尺寸，保持布局
@media (min-width: 1200px) {
  .membership-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 32px;
  }
  
  .level-card {
    padding: 32px;
    margin-bottom: 24px;
  }
  
  .page-title {
    font-size: 28px;
    margin-bottom: 32px;
  }
  
  .level-title {
    font-size: 24px;
  }
  
  .join-button {
    font-size: 18px;
  }
}
</style>